// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"f7f791c4","250":"f1c14860","453":"f0abf75a","668":"599d617a"}[chunkId] + ".chunk.js";
};